export const formMessages = {
    required: () => 'Required'
};
